import { render } from "./Sectores.vue?vue&type=template&id=72134630&scoped=true"
import script from "./Sectores.vue?vue&type=script&lang=js"
export * from "./Sectores.vue?vue&type=script&lang=js"

import "./Sectores.vue?vue&type=style&index=0&id=72134630&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72134630"

export default script